module.exports = __webpack_public_path__ + "static/media/image4.ebcd8a40.jpg";